<template>
  <div>
    <div class="form-group-style">
      <el-form class="form-container" :model="info" ref="biddingLinkForm" :rules="linkRules" >
          <div class="form-item bidding-tips">
            <div class="form-label">
                <span class="label">功能说明：</span>
            </div>
            <div class="form-input-item">
                <el-form-item v-if="isLoushi">
                    <p>1.本功能适用于给{{siteName}}平台PC端、M端和百度小程序的页面，生成各推广渠道的竞价链接地址，用于竞价投放使用。</p>
                    <p>2.PC端/M端页面URL地址需为{{host}}域名下的地址；百度小程序页面URL需为pages/的格式</p>
                    <p>3.楼盘详情页不支持在此生成竞价链接，在楼盘管理中配置渠道的400号码后即可直接复制竞价链接。</p>
                </el-form-item>
                <el-form-item v-else>
                    <p>1.本功能适用于给{{siteName}}平台PC端、M端的页面，生成各推广渠道的竞价链接地址，用于竞价投放使用。</p>
                    <p>2.页面URL地址需为{{host}}域名下的地址。</p>
                    <p>3.楼盘详情页不支持在此生成竞价链接，在楼盘管理中配置渠道的400号码后即可直接复制竞价链接。</p>
                </el-form-item>
            </div>
        </div>
        <div class="form-item">
          <div class="form-label">
              <span class="label">终端：</span>
              <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item v-if="isLoushi">
              <el-select  placeholder="请选择终端" class="input-control" v-model="info.terminal_id">
                <el-option value="1" label="PC端"></el-option>
                <el-option value="2" label="M端"></el-option>
                <el-option value="3" label="百度小程序"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else>
              <el-select  placeholder="请选择终端" class="input-control" v-model="info.terminal_id">
                <el-option value="1" label="PC端"></el-option>
                <el-option value="2" label="M端"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
            <div class="form-label">
                <span class="label">页面URL地址：</span>
                <label class="warn">*</label>
            </div>
            <div class="form-input-item">
                <el-form-item prop="url" >
                    <el-input :placeholder="info.terminal_id == '3'?'pages/':'http://'" class="input-control" v-model="info.url" ></el-input>
                </el-form-item>
            </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">推广渠道</span>
            <label class="warn">*</label>
          </div>
          <div class="form-input-item">
            <el-form-item prop="channel_id">
              <el-select  placeholder="请选择推广渠道" class="input-control" v-model="info.channel_id" :disabled="!info.terminal_id">
                <el-option v-for="item in channelList" :key="item.id" :value="item.id" :label="item.name" :disabled="item.disabled"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label">
            <span class="label">竞价链接地址</span>
          </div>
          <div class="form-input-item">
            <el-form-item>
                <el-input type="textarea" class="input-control" v-model="linkResult" ></el-input>
            </el-form-item>
          </div>
            <div class="form-input-item">
            <el-form-item>
                <el-button size="mini" v-show="showCopy" style="margin-left: 20px;" @click="copyPath(linkResult)">复制链接</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="form-button">
          <el-button type="primary"  @click="creatLink('biddingLinkForm')">生 成</el-button>
          <el-button type="info" plain @click="toWelcome()">取 消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getFormChannels } from '@/service/customer'
import { getBiddingUrl } from '@/service/user'
import { mapGetters } from "vuex";
export default {
  name: "List",
  data() {
    const validateLink = (rule, value, callback) => {
        const domain=document.domain
        var host = window.serverConfig[window.siteMap[domain]].HOST;
        var str;
        var tmpArr;
        if(this.info.terminal_id == '3'){
          if(value === ''){
              callback(new Error(`请输入百度小程序页面路径`))
              return
          }
          if(value.indexOf('pages/')<0){
              callback(new Error(`请使用正确的百度小程序页面路径`))
              return
          }
          if(value.indexOf('channel=')>-1){
              callback(new Error(`当前页面路径已是竞价链接`))
              return
          }
          if(value.indexOf('houseId=')>-1){
              callback(new Error(`楼盘详情页不支持在此生成竞价链接，请在楼盘管理中操作`))
          }else{
              callback()
          }
        }else{
          if(value === ''){
              callback(new Error(`请输入url地址`))
              return
          }
          if(value.indexOf(host)<0 || value.indexOf('http')<0){
              callback(new Error(`请使用正确的url地址`))
              return
          }else{
            str =value.split("//")[1];
            tmpArr = str.split('/');
          }
          if(value.indexOf('channel=')>-1){
              callback(new Error(`当前url地址已是竞价链接`))
              return
          }
          if((tmpArr.length == 3 && tmpArr[1] == 'loupan' && tmpArr[2].indexOf('html')>-1) || (tmpArr[0].indexOf('m.')>-1 && tmpArr.length == 4 && tmpArr[2] == 'loupan' && tmpArr[3].indexOf('html')>-1 )){
              callback(new Error(`楼盘详情页不支持在此生成竞价链接，请在楼盘管理中操作`))
          }else{
              callback()
          }
        }
    }
    return {
        info:{
            url:'',
            channel_id:'',
            terminal_id:'',

        },
        channelList:[],
        linkResult:'',
        showCopy:false,
        linkRules:{
          channel_id: [
            { required: true, message: '请选择推广渠道', trigger: 'change' }
          ],
          url: [
              {required: true, validator: validateLink, trigger: 'blur' }
          ],
        },
        host:'',
        siteName:'',
        isLoushi:false
     
    };
  },
  mounted() {
    var domain=document.domain
    this.host = window.serverConfig[window.siteMap[domain]].HOST;
    this.siteName = window.serverConfig[window.siteMap[domain]].title;
    this.initTypeList();
    if(this.host == "loushi.com"){
        this.isLoushi= true
    }
  },
  watch:{
    ['info.terminal_id']:{
      handler(val){
        this.info.channel_id = '';
        if(this.info.terminal_id == '3'){
          this.channelList = this.channelList.map(item => {
            if(item.id == '2' || item.id == '5'){
              item.disabled = false
            }else{
              item.disabled = true
            }
            return item
          })
        }else{
          this.channelList = this.channelList.map(item => {
              item.disabled = false
            return item
          })
        }
      },
      immediate:true
    }
  },
  methods: {
   
    /** 获取推广渠道列表 */
    async initTypeList () {
        try {
            const res = await getFormChannels()
            let data =res
            data.splice(0,1)
            this.channelList = data
        } catch (error) {
            const message = error.message
            this.$message({
                type: 'error',
                message: message || '初始化推广列表失败'
            })
        }
    },
    /** 复制竞价链接 */
    copyPath (url = '') {
        let oInput = document.createElement('input')
        oInput.value = url
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        this.$message({
            message: '复制成功',
            type: 'success'
        });
        oInput.remove()
    },
    creatLink(formName){
      this.linkResult="";
      this.$refs[formName].validate((valid) => {
            if (!valid) return null
            let str =this.info.url;
            if(this.info.terminal_id != '3'){
              if(str.indexOf("?")>-1){
                  let size =str.indexOf("?");
                  this.info.url=str.substring(0,size)
              }
            }
            getBiddingUrl(this.info).then(res => {
              this.linkResult=res.bidding_link;
              this.showCopy=true;
              }).catch(err => {
                  const message = err.message;
                  this.$message({
                      message: message || "生成推广链接失败",
                      type: "error",
                      duration: 3 * 1000
                  });
          });
            
        })
    },
    resetForm() {
      this.$refs.formRules && this.$refs.formRules.clearValidate();
    },
    toWelcome() {
      this.$router.push("/home/index/welcome");
    }
  }
};
</script>
<style scoped lang="less">
.form-group-style {
  min-height: 600px;
  background-color: #fff;
}
.bidding-tips .form-input-item{
    width:50%!important;
}

</style>